import { MaybeRef } from '@vueuse/core'
import { computed, ComputedRef, unref } from 'vue'
import distance from '@turf/distance'
import { Timer } from '../types/timers'
export type UseOdometerDistanceReturn = {
  endOdometerGuess: ComputedRef<number>
}
type Units = Parameters<typeof distance>[2]

type Options = {
  /** decimal digits to returns to, with 0 being an integer*/
  round?: number | undefined
}

export const useOdometerDistance = (
  startOdometer: MaybeRef<number>,
  timer: MaybeRef<Timer>,
  options: Units & Options = { units: 'miles' }
): UseOdometerDistanceReturn => {
  //American default here
  if (typeof options.units === 'undefined') options.units = 'miles'
  //Round function if present
  // const round = (input: number) => {
  //   if (typeof options.round !== 'undefined') {
  //     return (
  //       Math.round((input + Number.EPSILON) * Math.pow(10, options.round)) /
  //       Math.pow(10, options.round)
  //     )
  //   } else {
  //     return input
  //   }
  // }
  //Simple  point to  point calc using turf
  const turfDistance = (from: [lng: number, lat: number], to: [lng: number, lat: number]) => {
    return distance(from, to, { units: options.units })
  }
  /**
   * Calculates a timers distance by the first and last GPS point.
   * If no timers are present, it just returns the start Odometer value
   */
  const endOdometerGuess = computed(() => {
    if (typeof unref(timer) === 'undefined') return unref(startOdometer)
    const distanceTraveled =
      unref(timer).data?.location?.length > 0
        ? turfDistance(
            [unref(timer).data.location[0].longitude, unref(timer).data.location[0].latitude],
            [
              unref(timer).data.location[unref(timer).data.location.length - 1].longitude,
              unref(timer).data.location[unref(timer).data.location.length - 1].latitude,
            ]
          )
        : 0
    return unref(startOdometer) + Math.round(distanceTraveled) + 1
  })
  return {
    endOdometerGuess,
  }
}
